import {onActivated, onDeactivated, ref} from 'vue';
import {useEventListener} from '@vueuse/core';
import {EventIdType} from '@/enum/haboEventId';
import {haboTimeEnd, haboTimeStart} from '@/plugins/haboConfig';

const useTimeReport = (eventName: keyof EventIdType) => {
  const curActive = ref<boolean>(true);
  const handleVisibleChange = () => {
    if (!curActive.value) {
      return;
    }
    // 用户离开了当前页面(主要是处理按了home键，页面在后台运行的情况)
    if (document.visibilityState === 'hidden') {
      haboTimeEnd(eventName);
    }
    // 用户打开或回到页面
    if (document.visibilityState === 'visible') {
      haboTimeStart(eventName);
    }
  };
  useEventListener(document, 'visibilitychange', handleVisibleChange);
  onActivated(() => {
    curActive.value = true;
    haboTimeStart(eventName);
  });
  onDeactivated(() => {
    curActive.value = false;
    haboTimeEnd(eventName);
  });
};

export default useTimeReport;
